__turbopack_context__.v({
  "party-grid": "PartyList-module-scss-module__EdJJba__party-grid",
  "party-list": "PartyList-module-scss-module__EdJJba__party-list",
  "party-list__cta": "PartyList-module-scss-module__EdJJba__party-list__cta",
  "party-list__item": "PartyList-module-scss-module__EdJJba__party-list__item",
  "party-list__item--last": "PartyList-module-scss-module__EdJJba__party-list__item--last",
  "party-list__listing": "PartyList-module-scss-module__EdJJba__party-list__listing",
});
